<!--<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-spin-rotate" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>-->
<ngx-spinner type="ball-scale-ripple">
  <p style="color: white"> {{ 'spinner.message' | translate }} </p>
</ngx-spinner>
